/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ITipoCuentaBancaria from 'Infotrack@Modelos/administracion/tipoCuentaBancaria/entidades/tipoCuentaBancaria';
import { AnyAction } from 'redux';

export interface IEstadoTipoCuentaBancaria {
    estadoFormulario: boolean;
    entidadTipoCuentaBancaria: ITipoCuentaBancaria | null;
    recargarTabla: boolean;
    tipoFormulario: TipoFormulario;
}

export const estadoIncial: IEstadoTipoCuentaBancaria = {
    entidadTipoCuentaBancaria: null,
    estadoFormulario: false,
    recargarTabla: false,
    tipoFormulario: TipoFormulario.Creacion,
};

export enum acciones {
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
}

export const reductor = (estado: IEstadoTipoCuentaBancaria, { type, payload }: AnyAction) => {
    switch (type) {
        case 'CAMBIAR_ESTADO_FORMULARIO': {
            return {
                ...estado,
                entidadTipoCuentaBancaria: payload ? payload.entidadTipoCuentaBancaria : null,
                estadoFormulario: !estado.estadoFormulario,
                tipoFormulario: payload ? payload.tipoFormulario : estado.tipoFormulario,
            };
        }
        case 'RECARGAR_TABLA':
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };

        default:
            return estado;
    }
};
